export const Perfil = {
  "Meu Perfil": "My Profile",
  "Código": "Code",
  "Alterar senha": "Change Password",
  "Sair": "Sign Out",
  "Dados Pessoais": "Personal Information",
  "Email:": "Email:",
  "Função:": "Role:",
  "Turno:": "Shift:",
  "Contato": "Contact",
  "Adicionar Whatsapp": "Add Whatsapp",
  "Dados da Empresa": "Company Information",
  "Nome:": "Name:",
  "Data de admissão:": "Admission Date:",
  "Telefone:": "Phone:",
  "Visualizar LinkedIn": "View LinkedIn",
  "Adicionar LinkedIn": "Add LinkedIn",
  "Tivemos um problema com a conexão. Tente novamente atualizando a página.": "We had a problem with the connection. Please try again by refreshing the page.",
  "Aviso": "Notice",
  "Não foi possivel realizar o envio da imagem. Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB.": "The image could not be uploaded. Reason: file too large, please send a file smaller than 2MB."
};


// WEBPACK FOOTER //
// ./src/resources/enUS/Perfil.js